import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../api/client';
import AuthShell, { Field } from '../components/layout/AuthShell';
import AlertMessage from '../components/ui/AlertMessage';
import PasswordInput from '../components/ui/PasswordInput';

/**
 * Az app SAJÁT belépésének regisztrációja (2026-10-08, C:\ccc\app-fiok-meghivo-terv.txt). A tulajdonos: „az app oldalon
 * lenne egy regisztrációs oldal amihez ugye nincs gomb, a dc bot generálta egy lejárós kódot … és beregisztrál egy másik
 * fiókot oda”. A kódot a stáb adja a ticketben (Discord-bot /invite, 1 óra, egyszer használható); a link a kódot is hozza
 * (/register?code=…). A belépés a vevő MortisCodex-fiókjához kötődik — ha már volt app-belépése, ez lecseréli.
 * Kilépve elérhető, de SEHONNAN nem vezet ide link.
 */
export default function RegisterPage() {
  const [params] = useSearchParams();
  const [form, setForm] = useState({ code: params.get('code') || '', username: '', password: '', confirm: '' });
  const [error, setError] = useState(null);
  const [done, setDone] = useState(null);
  const [loading, setLoading] = useState(false);
  const set = (k) => (v) => setForm(p => ({ ...p, [k]: typeof v === 'string' ? v : v.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (form.password !== form.confirm) {
      setError('The two passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      const res = await api.post('/auth/register', { code: form.code, username: form.username, password: form.password });
      setDone(res.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <AuthShell bar="Create login" title="Your app login is ready"
                 subtitle={`Sign in here and in the loader as ${done.username}.`}>
        <Link to="/login" className="btn-primary w-full text-center">Sign in</Link>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      bar="Create login"
      title="Create your app login"
      subtitle="Use the code you got in your Discord ticket. It is valid for one hour."
    >
      <AlertMessage msg={error ? { type: 'error', text: error } : null} className="" />

      <form onSubmit={handleSubmit} className="flex flex-col gap-[18px]">
        <Field label="Code" htmlFor="reg-code">
          <input id="reg-code" type="text" className="input font-mono tracking-[0.12em] uppercase"
                 placeholder="XXXXX-XXXXX" value={form.code} onChange={set('code')}
                 autoComplete="one-time-code" required />
        </Field>

        <Field label="Username" htmlFor="reg-user" hint="3–20 characters: letters, numbers and _.">
          <input id="reg-user" type="text" className="input" value={form.username} onChange={set('username')}
                 autoComplete="username" required />
        </Field>

        <Field label="Password" htmlFor="reg-pass" hint="At least 8 characters, with an uppercase letter and a number.">
          <PasswordInput id="reg-pass" value={form.password} onChange={set('password')} autoComplete="new-password" required />
        </Field>

        <Field label="Confirm password" htmlFor="reg-pass2">
          <PasswordInput id="reg-pass2" value={form.confirm} onChange={set('confirm')} autoComplete="new-password" required />
        </Field>

        <button type="submit" className="btn-primary w-full" disabled={loading}>
          {loading ? 'Creating…' : 'Create login'}
        </button>
      </form>
    </AuthShell>
  );
}
